module.exports = "<h1 class=\"gw-page-title gw-mb10\">\r\n    <div class=\"gw-inline-back-nav\">\r\n        <a href=\"\">\r\n            <img ng-click=\"goBack()\" src=\"../styles/images/common/back_to_home.png\">\r\n        </a>\r\n        {{title}}\r\n    </div>\r\n</h1>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/directives/templates/back-button.html
// module id = 763
// module chunks = 0